module.exports = __webpack_public_path__ + "static/media/logo.30ba9016.svg";